import Axios from 'axios'
import * as React from 'react'
import {AttachmentsViewer} from '../../core/components/Controls/Attachments/AttachmentsViewer2'
import OverlayLoader from '../../core/components/Loading/OverlayLoading'
import {AttachmentInfo, AttachmentInfos} from '../../core/interfaces/models'
import {config} from '../../core/reducers/config'
import {LinearProgress} from '@mui/material'
import {Feature} from '../../core/models'

interface Props {}

interface State {
  loading: boolean
  file?: AttachmentInfo
  TiffName: string
  afterSuccess: boolean
  error: string
  progress: number
  status: string
}

export class TiffImport extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      afterSuccess: false,
      loading: false,
      TiffName: '',
      error: '',
      progress: 0,
      status: ''
    }
    this.getOwnMap()
  }
  public statusMap = new Map<number, string>()
  getProjectionSelector = (): JSX.Element => {
    return (
      <div style={{display: 'flex', justifyContent: 'strech', width: '100%'}}>
        <input
          className="form-control"
          style={{margin: '0 10px 0 0'}}
          value={this.state.TiffName}
          onChange={s => {
            this.setState({...this.state, TiffName: s.target.value, error: ''})
          }}
        ></input>
      </div>
    )
  }
  getAttachmentsControl = () => {
    const adds: AttachmentInfos = {}
    if (this.state.file) {
      adds[this.state.file.name] = this.state.file
    }
    return (
      <div style={{margin: '5px'}}>
        <AttachmentsViewer
          attachments={{}}
          deletes={{}}
          updates={{}}
          adds={adds}
          acceptTypes={'.tiff,.tif'}
          maxNumber={1}
          onAttachmentsChange={changes => {
            const addedFiles = Object.keys(changes.adds)
            let file: AttachmentInfo | undefined
            if (addedFiles.length > 0) {
              file = changes.adds[addedFiles[0]]
            }
            this.setState({...this.state, file: file, error: ''})
          }}
          feature={new Feature({})}
          uploadToArchive={false}
        ></AttachmentsViewer>
      </div>
    )
  }
  getContainer = (content: JSX.Element, title: string | JSX.Element, margin?: string): JSX.Element => {
    return (
      <div style={{margin, display: 'flex'}}>
        <div style={{minWidth: '40%', maxWidth: '40%', display: 'flex', alignItems: 'center'}}>{title}</div>
        {content}
      </div>
    )
  }
  getExecuteButton = () => {
    return (
      <button
        type="button"
        className="button width"
        disabled={!this.state.file}
        onClick={() => {
          const formData = new FormData()
          formData.append('File', this.state.file!.file!, this.state.file!.name)
          formData.append('Name', this.state.TiffName)
          this.setState({...this.state, loading: true}, () => {
            Axios.post(config.getConfig().urls.xyApiUrl + '/UploadTiff', formData, {
              headers: {'Content-Type': `multipart/form-data;`},
              onUploadProgress: progressEvent => {
                const progress = progressEvent.total ? (progressEvent.loaded / progressEvent.total) * 100 : 0
                this.setState({...this.state, progress: progress})
              }
            })
              .then(r => {
                this.setState({...this.state, afterSuccess: true, error: '', loading: false})
              })
              .catch(error => {
                if (error.response && error.response.data && error.response.data) {
                  this.setState({...this.state, error: error.response.data})
                } else {
                  this.setState({...this.state, error: 'Възникна грешка ' + error.message, loading: false})
                }
              })
          })
        }}
      >
        Импорт
      </button>
    )
  }
  afterSuccess() {
    return (
      <div>
        <div className="success-div">Успешен импорт</div>
        <button
          type="button"
          className="button width"
          onClick={() => {
            this.setState({...this.state, afterSuccess: false, file: undefined})
          }}
        >
          Нов импорт
        </button>
      </div>
    )
  }

  onerror() {
    return (
      <div className="error-div">
        <button
          type="button"
          className="button width"
          onClick={() => {
            this.setState({...this.state, afterSuccess: false, file: undefined, error: ''})
          }}
        >
          Нов импорт
        </button>
        {this.state.error}
      </div>
    )
  }

  public getOwnMap() {
    this.statusMap.set(0, 'В процес на обработка')
    this.statusMap.set(1, 'Готов')
    this.statusMap.set(2, 'Неуспешен')
    this.statusMap.set(3, 'Подаден')
    this.statusMap.set(4, 'Етап 1')
    this.statusMap.set(5, 'Етап 2')

    Axios.get(process.env.HOST_API_URL + '/GetTiffs').then(response => {
      let str = ''
      for (let i = 0; i < response.data.length; i++) {
        str += `<div style="display: flex; align-items: center; margin: 5px 0px; padding: 5px; border: 1px solid #ccc; border-radius: 5px;">`
        str += `<div style="margin: 0px 5px; width: 300px">${response.data[i].Name}</div>`
        str += `<div style="margin: 0px 5px;">${this.statusMap.get(response.data[i].Status)}</div>`
        str += `</div>`
      }
      this.setState({...this.state, status: str})
    })
  }

  render() {
    return (
      <div style={{padding: '10px', boxSizing: 'border-box', height: '80%', overflow: 'auto'} as React.CSSProperties}>
        {this.state.afterSuccess ? (
          this.afterSuccess()
        ) : this.state.error ? (
          this.onerror()
        ) : (
          <div style={{position: 'relative'}}>
            <OverlayLoader show={this.state.loading}></OverlayLoader>

            {this.getContainer(this.getAttachmentsControl(), 'Прикачете файл', `10px 0px`)}
            {this.getContainer(this.getProjectionSelector(), 'Име', `10px 0px`)}
            {this.getExecuteButton()}
            {this.state.loading ? <LinearProgress variant="determinate" value={this.state.progress} /> : null}

            <div dangerouslySetInnerHTML={{__html: this.state.status}}></div>
          </div>
        )}
      </div>
    )
  }
}
